export const InspectionResource = [
  {
    name: '3rd-cancel-inspection',
    create: '/third-party/inspections/:id/cancel',
  },
];
